/**
 * Holds all preview related components
 * @module PreviewPane
 * @category Display Components
 */

import {
	InPresentationMode,
	ShowLandscapePreview,
	ShowPortraitPreview,
} from "../../state/uiAtoms";

import LandscapeView from "./LandscapePreviewPane";
import PortraitView from "./PortraitPreviewPane";
import PreviewControlBar from "./PreviewControlBar";
import styled from "styled-components";
import { useRecoilValue } from "recoil";

export const StyledPreview = styled.div<{ $show: boolean }>`
  align-self: center;
  background: #FFF;
  border: 1px solid #DDD;
  box-shadow: 0 4px 16px rgb(0 0 0 / 12%), 0 1px 4px rgb(0 0 0 / 8%);
  z-index: 1;
  display: ${(props) => (props.$show ? "flex" : "none")};

  & > div {
    width: 100%;
    height: 100%;
  }
`;

const StyledPreviewPane = styled.div<{
	$showPortraitPreview: boolean;
	$showLandscapePreview: boolean;
	$inPresentationMode: boolean;
}>`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: auto;
  grid-template-areas: "landscape-preview portrait-preview";
  grid-area: previews;
  position: relative;
  height: 100%;
  width: 100%;
  gap: 1svw;
  padding: 0;

  .landscape {
    align-self: center;
    aspect-ratio: 1.68/1;
    grid-area: landscape-preview;
    width: ${(props) => {
			if (props.$inPresentationMode) return "100%";
			return props.$showPortraitPreview ? "36svw" : "46svw";
		}};
    height: auto;
    justify-self: flex-end;
    overflow: hidden;
    position: relative;
  }

  .portrait {
    align-self: center;
    aspect-ratio: 9/16;
    grid-row: 1;
    grid-column: ${(props) => (props.$showLandscapePreview ? "2" : "1 / -1")};
    width: ${(props) => (props.$showLandscapePreview ? "11svw" : "auto")};
    height: ${(props) => (props.$showLandscapePreview ? "auto" : "92%")};
    max-height: 92%;
    justify-self: ${(props) => (props.$showLandscapePreview ? "flex-start" : "center")};
    overflow: hidden;
    position: relative;
  }
`;

function PreviewPane() {
	const showPortraitPreview = useRecoilValue(ShowPortraitPreview);
	const showLandscapePreview = useRecoilValue(ShowLandscapePreview);
	const inPresentationMode = useRecoilValue(InPresentationMode);

	return (
		<StyledPreviewPane
			className="qp-preview-pane"
			$showPortraitPreview={showPortraitPreview}
			$showLandscapePreview={showLandscapePreview}
			$inPresentationMode={inPresentationMode}
		>
			<PreviewControlBar />
			<LandscapeView
				showPortraitPreview={showPortraitPreview}
				showLandscapePreview={showLandscapePreview}
			/>
			<PortraitView
				showLandscapePreview={showLandscapePreview}
				showPortraitPreview={showPortraitPreview}
			/>
		</StyledPreviewPane>
	);
}

export default PreviewPane;
